import rootStore from "./store";

export default rootStore;
